(() => {
  const initializeVideoGallery = (section) => {
    if (!section || section.dataset.bhlVideoGalleryReady === 'true') return;

    section.querySelectorAll('[data-bhl-video-play]').forEach((button) => {
      button.addEventListener('click', () => {
        const videoId = button.dataset.youtubeId || '';
        if (!/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;

        const media = button.closest('[data-bhl-video-media]');
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
        iframe.title = button.dataset.videoTitle || 'Bright Home Lights video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        media.replaceChildren(iframe);
      });
    });

    section.dataset.bhlVideoGalleryReady = 'true';
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-bhl-video-gallery]').forEach(initializeVideoGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
